import { ReactComponent as IconBrokenLink } from './brokenLink.svg';

export const BrokenLink = ({ ...props }): JSX.Element => (
  <IconBrokenLink {...props} />
);
